import { render, staticRenderFns } from "./SingleItemBundleDetails.vue?vue&type=template&id=12a6511a"
import script from "./SingleItemBundleDetails.vue?vue&type=script&lang=js"
export * from "./SingleItemBundleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports